import { render, staticRenderFns } from "./podium-form.vue?vue&type=template&id=62a6087a"
import script from "./podium-form.vue?vue&type=script&lang=js"
export * from "./podium-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports